export interface StatusBarState {
  speed: number;
  totalTicks: number;
  isRunning: boolean;
  mode: 'worker' | 'inline';
}

const THROTTLE_MS = 200;

export class StatusBar {
  readonly el: HTMLDivElement;
  private speedLabel: HTMLSpanElement;
  private ticksLabel: HTMLSpanElement;
  private runningLabel: HTMLSpanElement;
  private modeLabel: HTMLSpanElement;
  private lastTicksUpdate: number = 0;
  private state: StatusBarState;

  constructor(container: HTMLElement) {
    this.state = { speed: 1, totalTicks: 0, isRunning: false, mode: 'worker' };

    this.el = document.createElement('div');
    this.el.className = 'status-bar';

    const speedGroup = document.createElement('span');
    speedGroup.className = 'status-bar-item';
    const speedIcon = document.createElement('span');
    speedIcon.textContent = 'Speed: ';
    speedGroup.appendChild(speedIcon);
    this.speedLabel = document.createElement('span');
    this.speedLabel.textContent = '1x';
    speedGroup.appendChild(this.speedLabel);
    this.el.appendChild(speedGroup);

    const ticksGroup = document.createElement('span');
    ticksGroup.className = 'status-bar-item';
    const ticksIcon = document.createElement('span');
    ticksIcon.textContent = 'Ticks: ';
    ticksGroup.appendChild(ticksIcon);
    this.ticksLabel = document.createElement('span');
    this.ticksLabel.textContent = '0';
    ticksGroup.appendChild(this.ticksLabel);
    this.el.appendChild(ticksGroup);

    const runningGroup = document.createElement('span');
    runningGroup.className = 'status-bar-item';
    this.runningLabel = document.createElement('span');
    this.runningLabel.textContent = 'Stopped';
    runningGroup.appendChild(this.runningLabel);
    this.el.appendChild(runningGroup);

    const modeGroup = document.createElement('span');
    modeGroup.className = 'status-bar-item status-bar-mode';
    this.modeLabel = document.createElement('span');
    this.modeLabel.textContent = 'Worker';
    modeGroup.appendChild(this.modeLabel);
    this.el.appendChild(modeGroup);

    container.appendChild(this.el);
  }

  updateSpeed(speed: number): void {
    this.state.speed = speed;
    this.speedLabel.textContent = String(speed) + 'x';
  }

  updateTicks(ticks: number): void {
    const now = Date.now();
    if (now - this.lastTicksUpdate < THROTTLE_MS) return;
    this.lastTicksUpdate = now;
    this.state.totalTicks = ticks;
    this.ticksLabel.textContent = String(ticks);
  }

  updateRunning(running: boolean): void {
    this.state.isRunning = running;
    this.runningLabel.textContent = running ? 'Running' : 'Stopped';
    if (running) {
      this.runningLabel.classList.add('status-bar-running');
    } else {
      this.runningLabel.classList.remove('status-bar-running');
    }
  }

  updateMode(mode: 'worker' | 'inline'): void {
    this.state.mode = mode;
    if (mode === 'inline') {
      this.modeLabel.textContent = '单线程';
      this.modeLabel.classList.add('status-bar-inline');
      this.modeLabel.classList.remove('status-bar-worker');
    } else {
      this.modeLabel.textContent = 'Worker';
      this.modeLabel.classList.add('status-bar-worker');
      this.modeLabel.classList.remove('status-bar-inline');
    }
  }

  destroy(): void {
    if (this.el.parentNode) {
      this.el.parentNode.removeChild(this.el);
    }
  }
}
